export default {
	'SET_USER' (state, u) {
		state.user = u
        sessionStorage.setItem("user", JSON.stringify(u) || null)
    },

    'SET_USER_LOCAL' (state, u) {
        state.user_local = u
    },

	'SET_TOKEN' (state, token) {
        //console.log(token)

        //state.token = {headers:{ authorization: token }}
        state.token = token
        sessionStorage.setItem("token", JSON.stringify(state.token) || null)

    },


    'SET_MENU'(state, m){
        state.menu = m
        sessionStorage.setItem("menu", JSON.stringify(m) || null )
    },

    'SET_ROUTES' (state, routes) {
        state.routes = routes
    },

    'SET_APPVERSION'(state, versoes)
    {
        state.versoes = versoes
    },

    'LOGOUT'(state){
        sessionStorage.removeItem("user")
        sessionStorage.removeItem("token")
        sessionStorage.removeItem("menu")
        state.user  = {}
        state.token = ''
        state.menu  = []
    },

    'SET_EMPRESA_QUERO_TAXI'(state, empresa) {
        state.empresaQueroTaxi = empresa
    },

    'SET_SHOW_INFORME_LGPD'(state, status) {
        state.showInformeLGPD = status
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/system/mutations.js